import { memo, useEffect, useCallback, useState } from 'react';

import { View, Pressable, Text, Image, StyleSheet } from 'react-native';

import { useSelector } from 'react-redux';

import { COLOR, NAVBAR_BUTTON_DIM, THEME } from '../constants/styles';
import { EMPLOYER_TYPE_AIRFORCE } from '../constants/employerTypes';

import { canSeeAllResidentsCalendar, shouldShowAllResidentsInCal } from './calendar/selector';
import { getCurrentEmployer } from '../selectors/employers';

import Notifications from './notifications/notifications';
import MessagingSubNav from './messaging/sub_nav';
import Broadcasts from './messaging/broadcasts';
import SelectCaseBtn from './cases/select_case_button';
import ProfileMenu from './nav_menus/profile_menu';

const NOTIFICATIONS_ICON = require('../../resources/nav/icon-notifications.png');
const NO_NOTFICATIONS_ICON = require('../../resources/nav/icon-no-notifications.png');
const BROADCASTS_ICON = require('../../resources/nav/icon-broadcasts-trimmed.png');
const MYPROFILE_ICON = require('../../resources/icon-myprofile.png');

const NAV_HEIGHT = NAVBAR_BUTTON_DIM;

const ICON_SIZE = 20;

export default memo((props) => {
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [notificationsMenuOpen, setNotificationsMenuOpen] = useState(false);
  const [broadcastsOpen, setBroadcastsOpen] = useState(false);

  const canSeeAllResidentsOption = useSelector(canSeeAllResidentsCalendar);
  const showAllResidents = useSelector(shouldShowAllResidentsInCal);
  const badgeNum = useSelector((state) => state.entities.notifications.badge);
  const brodcastTapCounter = useSelector((state) => state.screens.messaging.brodcastTapCounter);

  const employer = useSelector(getCurrentEmployer);
  // const associatedEmployer = useSelector(getAssociatedEmployer);
  const isAirforceStaff = employer?.uiConfig?.type === EMPLOYER_TYPE_AIRFORCE;
  // const isAirforcePatient = !isAirforceStaff && associatedEmployer?.uiConfig?.type === EMPLOYER_TYPE_AIRFORCE;
  // const isAirforcePatient = true;

  const toggleAccountMenu = useCallback(() => {
    setProfileMenuOpen((open) => !open);
    setNotificationsMenuOpen(false);
    setBroadcastsOpen(false);
    props.onOpenMenu?.(!profileMenuOpen);
  }, [profileMenuOpen, props.onOpenMenu]);

  const toggleNotifications = useCallback(() => {
    setNotificationsMenuOpen((open) => !open);
    setProfileMenuOpen(false);
    setBroadcastsOpen(false);
    props.onOpenMenu?.(!notificationsMenuOpen);
  }, [notificationsMenuOpen, props.onOpenMenu]);

  const toggleBroadcasts = useCallback(() => {
    setBroadcastsOpen((open) => !open);
    setProfileMenuOpen(false);
    setNotificationsMenuOpen(false);
    props.onOpenMenu?.(!broadcastsOpen);
  }, [broadcastsOpen, props.onOpenMenu]);
  const openBroadcasts = useCallback(() => {
    setBroadcastsOpen(true);
    setProfileMenuOpen(false);
    setNotificationsMenuOpen(false);
    props.onOpenMenu?.(true);
  }, [props.onOpenMenu]);

  useEffect(() => {
    if (!props.menuOpen) {
      setProfileMenuOpen(false);
      setNotificationsMenuOpen(false);
      setBroadcastsOpen(false);
    }
  }, [props.menuOpen]);

  useEffect(() => {
    if (brodcastTapCounter) {
      openBroadcasts();
    }
  }, [brodcastTapCounter, openBroadcasts]);

  const handleAccountMenuItemPress = useCallback(() => {
    toggleAccountMenu();
  }, [toggleAccountMenu]);

  const { currentTab } = props;
  const currentScreenName = currentTab;

  return (
    <View style={styles.container}>
      <View style={styles.innerContainer}>
        <View style={styles.leftContainer}>
          {currentScreenName === 'Calendar' && !!isAirforceStaff && (
            <View style={styles.caseSelectContainer}>
              <SelectCaseBtn
                canSeeAllResidentsOption={canSeeAllResidentsOption}
                showAllResidents={showAllResidents}
                containerStyle={{ width: '100%' }}
              />
            </View>
          )}
          {currentScreenName === 'Messages' && <MessagingSubNav />}

          {!!props.internal && <Text style={styles.configuratorText}>BASE CONFIGURATOR</Text>}
        </View>

        <View style={styles.rightContainer}>
          <View style={styles.rightNavContainer}>
            <View style={[{ flexDirection: 'row' }]}>
              {!props.internal && (
                <>
                  <Pressable
                    key={`rightNavItem-Broadcasts`}
                    style={styles.rightNavItem}
                    onPress={toggleBroadcasts}
                  >
                    <Image
                      source={BROADCASTS_ICON}
                      style={[styles.icon, { width: 25, height: 25 }]}
                    />
                  </Pressable>
                  <Pressable
                    key={`rightNavItem-Notifications`}
                    style={styles.rightNavItem}
                    onPress={toggleNotifications}
                  >
                    <Image
                      source={!!badgeNum ? NOTIFICATIONS_ICON : NO_NOTFICATIONS_ICON}
                      resizeMode="contain"
                      style={[styles.icon, { width: 25, height: 25 }]}
                    />
                    {!!badgeNum && (
                      <View style={THEME.badgeContainer}>
                        <Text style={THEME.badgeText}>{badgeNum < 100 ? badgeNum : '99+'}</Text>
                      </View>
                    )}
                  </Pressable>
                </>
              )}
              <Pressable
                key={`rightNavItem-AccountMenu`}
                style={styles.rightNavItem}
                onPress={toggleAccountMenu}
              >
                <Image source={MYPROFILE_ICON} style={styles.icon} />
              </Pressable>
            </View>
          </View>
        </View>
      </View>
      <View
        style={[
          styles.dropdownMenu,
          {
            overflow: notificationsMenuOpen ? 'visible' : 'hidden',
            maxHeight: notificationsMenuOpen ? 400 : 0,
          },
        ]}
      >
        <View style={[styles.upTriangle, { marginRight: 60 }]} />
        <View style={styles.notificationsContainer}>
          <Notifications />
        </View>
      </View>

      <View
        style={[
          styles.dropdownMenu,
          {
            width: 400,
            overflow: broadcastsOpen ? 'visible' : 'hidden',
            height: broadcastsOpen ? 400 : 0,
            transition: 'height 250ms ease-out',
          },
        ]}
      >
        <View style={[styles.upTriangle, { marginRight: 120 }]} />
        {!!broadcastsOpen && <Broadcasts />}
      </View>
      <View
        style={[
          styles.dropdownMenu,
          {
            overflow: profileMenuOpen ? 'visible' : 'hidden',
            maxHeight: profileMenuOpen ? 400 : 0,
          },
        ]}
      >
        <View style={styles.upTriangle} />
        <View style={styles.accountMenuContainer}>
          <ProfileMenu onItemSelect={handleAccountMenuItemPress} internal={props.internal} />
        </View>
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    height: NAV_HEIGHT,
    backgroundColor: COLOR.contrast,
    borderBottomColor: COLOR.accent,
    borderBottomWidth: 2,
    borderStyle: 'solid',
    zIndex: 10,
  },
  innerContainer: {
    flex: 1,
    transition: 'padding 300ms ease-out',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  rightNavContainer: {
    ...THEME.basicRow,
    height: NAV_HEIGHT,
    margin: 0,
    padding: 0,
    marginRight: 10,
    marginLeft: 20,
    justifyContent: 'flex-end',
    alignItems: 'stretch',
  },
  rightNavItem: {
    flex: 1,
    justifyContent: 'center',
  },
  icon: {
    width: ICON_SIZE,
    height: ICON_SIZE,
    marginHorizontal: (NAV_HEIGHT - ICON_SIZE) / 2,
    resizeMode: 'contain',
    tintColor: COLOR.textLight,
  },
  dropdownMenu: {
    zIndex: 10,
    flex: 1,
    position: 'absolute',
    top: NAV_HEIGHT + 20,
    right: 18,
    backgroundColor: COLOR.contrast,
    borderRadius: 10,
    transition: 'max-height 250ms ease-out',
    minWidth: 100,
    overflow: 'hidden',
    boxShadow: `0 5px 20px 0 rgba(0,0,0,0.10)`,
  },
  upTriangle: {
    width: 0,
    height: 0,
    position: 'absolute',
    borderLeftColor: '#0000',
    borderRightColor: '#0000',
    right: ICON_SIZE / 2 - 2,
    top: -10,
    borderLeftWidth: 15,
    borderRightWidth: 15,
    borderBottomWidth: 15,
    borderBottomColor: COLOR.contrast,
  },
  notificationsContainer: {
    flexDirection: 'column',
    width: 650,
    flex: 1,
    borderRadius: 10,
    overflow: 'hidden',
  },
  accountMenuContainer: {
    paddingTop: 15,
    paddingBottom: 15,
    paddingRight: 60,
    flexDirection: 'column',
  },
  leftContainer: {
    flexGrow: 0.7,
    ...THEME.basicRow,
    height: NAV_HEIGHT,
  },
  rightContainer: {
    flexGrow: 0.3,
    ...THEME.basicRow,
    height: NAV_HEIGHT,
    justifyContent: 'flex-end',
  },
  caseSelectContainer: {
    width: '100%',
    maxWidth: 400,
    paddingLeft: 25,
  },
  configuratorText: {
    ...THEME.textSemibold,
    paddingLeft: 28,
    color: COLOR.greenColor,
  },
});
